<template>
  <div v-html="longFormHtml.body"></div>
</template>

<script>
import longFormHtml from '../../../assets/longFormHtml/longFormHtml.json'

export default {
  name: 'LongFormHTML',
  props: [ 'modalBody' ],
  data () {
    return {
      longFormHtml: ''
    }
  },
  mounted () {
    let dataPath = this.modalBody.split('.')
    let dataPathLength = dataPath.length
    let i = 0
    let longFormText = longFormHtml
    for (i = 0; i < dataPathLength; i++) {
      longFormText = longFormText[dataPath[i]]
    }
    this.longFormHtml = longFormText
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/LongFormHTML/LongFormHTML.vue?c26026c4